import { render } from "./ProductListings.vue?vue&type=template&id=1983e7c7"
import script from "./ProductListings.vue?vue&type=script&lang=js"
export * from "./ProductListings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/52/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
